import Component from '@glimmer/component';
import { CoreLayoutMain } from 'core/components';
import { boxPadding } from 'core/modifiers';
import NoRoleServiceCard from 'hcp/components/page/organizations/detail/no-role-service-card';
import TerraformWorkspaces from 'hcp/components/hcp/alert/terraform-workspaces';

/**
 * The organization to render details for.
 * @argument organization
 * @type {Object}
 */
/**
 *
 * `PageOrganizationsDetailRestrictedAccess` displays general information about HCP services
 *  and alerts user about their No Role status
 *
 *
 * ```
 * <Page::Organizations::Detail::RestrictedAccess
 *   @organization={{this.model.organization}}
 * />
 * ```
 *
 * @class PageOrganizationsDetailRestrictedAccess
 *
 */
export default class PageOrganizationsDetailRestrictedAccess extends Component {
  <template>
    <CoreLayoutMain>
      <:body>
        {{! This page does not have a header so we must place a padding on top to
    supplement the spacing that is lost by omitting the header block. }}
        <div
          class="organization-detail-overview"
          {{boxPadding "lg 0 0 0"}}
          data-test-organization-restricted-access-container
        >
          <div class="organization-detail-overview-card-grid">
            <NoRoleServiceCard @product="boundary" />
            <NoRoleServiceCard @product="consul" />
            <NoRoleServiceCard @product="packer" />
            <NoRoleServiceCard @product="terraform">
              <:alert>
                <TerraformWorkspaces />
              </:alert>
            </NoRoleServiceCard>
            <NoRoleServiceCard @product="vault" />
            <NoRoleServiceCard @product="radar" />
            <NoRoleServiceCard @product="secrets" />
            <NoRoleServiceCard @product="waypoint" />
          </div>
        </div>
      </:body>
    </CoreLayoutMain>
  </template>
}
